// @ts-nocheck
import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import TablePagination from '@mui/material/TablePagination';
import { TablePaginationActions } from './TablePaginationActions';
import { scrollToTop } from '../../helpers/dom';

interface IPaginationProps {
  labelRowsPerPage?: string;
  rowsPerPageOptions?: number[] | { label: string; value: number }[] | any;
  count: number;
  rowsPerPage: number;
  page: number;
  setPage: (newPage: number) => void;
  setRowsPerPage: (val: number) => void;
  scrollToTopOnPaging?: boolean;
}

export const Pagination: FC<IPaginationProps> = ({
  labelRowsPerPage,
  rowsPerPageOptions,
  count,
  rowsPerPage,
  page,
  setPage,
  setRowsPerPage,
  scrollToTopOnPaging = true
}) => {
  const classes = paginationStyles();
  const handleScrollToTop = () => {
    if (scrollToTopOnPaging) {
      setTimeout(() => scrollToTop(), 500);
    }
  };
  return (
    <TablePagination
      labelRowsPerPage={labelRowsPerPage}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions || [5, 10, 25, 50, 100]}
      component="div"
      classes={{
        root: classes.paginationRoot
      }}
      onPageChange={(e: any, newPage: number) => {
        setPage(newPage);
        handleScrollToTop();
      }}
      onRowsPerPageChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setRowsPerPage(parseInt(e.target.value, 10));
        handleScrollToTop();
      }}
      ActionsComponent={TablePaginationActions}
    />
  );
};

const paginationStyles = makeStyles((theme: Theme) => ({
  paginationRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&& .MuiTablePagination-selectRoot': {
      marginLeft: 0,
      marginRight: '5px'
    },
    '&& .MuiToolbar-gutters': {
      paddingLeft: 0
    },
    '&& .MuiTablePagination-actions': {
      marginLeft: 0
    },
    [theme.breakpoints.up('md')]: {
      '&& .MuiTablePagination-selectRoot': {
        marginLeft: '8px',
        marginRight: '32px'
      },
      '&& .MuiToolbar-gutters': {
        paddingLeft: 0
      },
      '&& .MuiTablePagination-actions': {
        marginLeft: '20px'
      }
    }
  }
}));
